<template>
  <div
    class="bg-action-default-hi rounded-lg relative flex flex-col justify-end space-y-16 overflow-hidden p-16"
  >
    <div class="space-y-8">
      <div class="text-static-default-hi mood-inverse heading-3">
        {{ i18n(translations.title) }}
      </div>
      <div class="text-static-default-hi mood-inverse body-2">
        {{ i18n(translations.subTitle) }}
      </div>
    </div>

    <div>
      <RevButton
        class="mood-inverse"
        :icon="IconExternalLink"
        size="small"
        target="_blank"
        :to="`https://repair.evy.eu/${locale}/backmarket?utm_source=header&utm_medium=website`"
        variant="primary"
      >
        {{ i18n(translations.buttonLabel) }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { RevButton } from '@ds/components/Button'
import { IconExternalLink } from '@ds/icons/IconExternalLink'

import translations from './RepairCard.translations'

const i18n = useI18n()
const locale = useI18nLocale()
</script>
